export default "__VITE_ASSET__BU88shN1__"